import React from 'react';
import './BotanicalDivider.css';

interface BotanicalDividerProps {
  style?: 'leaf' | 'vine' | 'simple';
  emoji?: string;
  spacing?: 'small' | 'medium' | 'large';
}

/**
 * BotanicalDivider - Decorative section dividers with botanical elements
 */
export const BotanicalDivider: React.FC<BotanicalDividerProps> = ({
  style = 'leaf',
  emoji = '🍃',
  spacing = 'medium',
}) => {
  if (style === 'simple') {
    return <div className={`botanical-divider botanical-divider--simple botanical-divider--spacing-${spacing}`} />;
  }

  if (style === 'vine') {
    return (
      <div className={`botanical-divider botanical-divider--vine botanical-divider--spacing-${spacing}`}>
        <svg className="botanical-divider__vine-svg" viewBox="0 0 800 40" preserveAspectRatio="none">
          <path
            d="M0,20 Q200,10 400,20 T800,20"
            fill="none"
            stroke="var(--forest-light)"
            strokeWidth="2"
          />
          <circle cx="200" cy="10" r="3" fill="var(--forest-medium)" />
          <circle cx="400" cy="20" r="3" fill="var(--forest-medium)" />
          <circle cx="600" cy="30" r="3" fill="var(--forest-medium)" />
        </svg>
      </div>
    );
  }

  // Default: leaf style
  return (
    <div className={`botanical-divider botanical-divider--leaf botanical-divider--spacing-${spacing}`}>
      <div className="botanical-divider__line" />
      <div className="botanical-divider__emoji">{emoji}</div>
      <div className="botanical-divider__line" />
    </div>
  );
};

export default BotanicalDivider;
